import { Button, InputField } from '@hakimo-ui/shared/ui-base';
import { FunnelIcon } from '@heroicons/react/24/outline';

interface Props {
  onClickAddProfile: () => void;
  onClickFilter: () => void;
  isLoading: boolean;
  hasFiltersApplied: boolean;
  searchValue: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedProfilesCount: number;
  onDeleteProfiles: () => void;
  canModifyProfiles: boolean;
}

export function TableHeader(props: Props) {
  const {
    onClickAddProfile,
    onClickFilter,
    isLoading,
    hasFiltersApplied,
    searchValue,
    onSearchChange,
    selectedProfilesCount,
    onDeleteProfiles,
    canModifyProfiles,
  } = props;

  return (
    <div className="bg-onlight-bg-1 dark:bg-ondark-bg-1 border-onlight-line-1 dark:border-ondark-line-1 flex items-center justify-between border-b p-4">
      <div className="flex items-center gap-4">
        {canModifyProfiles && (
          <Button
            variant="primary"
            onClick={onClickAddProfile}
            disabled={isLoading}
          >
            Add New Profile
            <span className="sr-only">Add New Profile</span>
          </Button>
        )}
        {selectedProfilesCount > 0 && canModifyProfiles && (
          <Button
            variant="error"
            onClick={onDeleteProfiles}
            disabled={isLoading}
          >
            Delete {selectedProfilesCount} profile
            {selectedProfilesCount > 1 ? 's' : ''}
            <span className="sr-only">Delete selected profiles</span>
          </Button>
        )}
      </div>
      <div className="flex items-center gap-4">
        <div className="w-64">
          <InputField
            label=""
            onChange={onSearchChange}
            value={searchValue}
            type="search"
            placeholder="Search by Name..."
          />
        </div>
        <Button
          variant="icon"
          badge={hasFiltersApplied}
          onClick={onClickFilter}
          disabled={isLoading}
        >
          <span className="sr-only">Open filters panel</span>
          <FunnelIcon className="h-5 w-5" aria-hidden="true" />
        </Button>
      </div>
    </div>
  );
}

export default TableHeader;
